import { lzSAtomWithLocalStorage } from '@lz-store/services';

const lzSAuthTokenAtom = lzSAtomWithLocalStorage<string>('authTokenState', '');

export default lzSAuthTokenAtom;
